import { createContext, useContext } from "react";

export const LanguageContext = createContext({
    lang: "pt",
    setLang: () => {},
    t: {},
});

export const useLang = () => useContext(LanguageContext);

export const dict = {
    pt: {
        meta: {
            title: "ANG — Engenharia Elétrica & SPDA | São Paulo e Região",
        },
        nav: {
            home: "Início",
            team: "Equipe",
            services: "Serviços",
            ti: "T.I",
            spda: "SPDA 3D",
            works: "Obras",
            coverage: "Cobertura",
            testimonials: "Depoimentos",
            quote: "Orçamento",
            cta: "Orçamento no WhatsApp",
        },
        hero: {
            badge: "Pronto para novos projetos — SP e região",
            lines: ["ENGENHARIA", "ELÉTRICA", "& PROTEÇÃO."],
            sub: "Instalações elétricas, planejamento Home & Building e SPDA — proteção contra descargas atmosféricas para residências, comércios e edifícios.",
            cta1: "Pedir orçamento no WhatsApp",
            cta2: "Explorar SPDA em 3D",
            chipTop: "SPDA · NBR 5419",
            chipBottom: "4 regiões atendidas em SP",
            metrics: [
                "Elétrica residencial, comercial e predial",
                "Planejamento Home & Building",
                "SPDA · proteção contra raios",
                "SP · Interior · Baixada · ABC",
            ],
        },
        marquee: [
            "INSTALAÇÕES ELÉTRICAS",
            "SPDA · NBR 5419",
            "PLANEJAMENTO HOME & BUILDING",
            "SÃO PAULO CAPITAL",
            "ABC PAULISTA",
            "BAIXADA SANTISTA",
            "INTERIOR PAULISTA",
            "ORÇAMENTO: (11) 94137-0079",
        ],
        services: {
            eyebrow: "O que fazemos",
            title: "Elétrica completa, do plano ao para-raios",
            sub: "Da concepção do projeto à proteção contra raios: um único time para toda a parte elétrica do seu imóvel.",
            items: [
                {
                    tag: "01 · ELÉTRICA",
                    title: "Instalações elétricas",
                    desc: "Execução e manutenção de instalações elétricas para residências, comércios e edifícios — do ponto de energia novo à adequação do quadro existente.",
                    bullets: [
                        "Quadros, circuitos e disjuntores",
                        "Iluminação, tomadas e pontos de força",
                        "Adequações e melhorias elétricas",
                    ],
                },
                {
                    tag: "02 · PLANEJAMENTO",
                    title: "Planejamento Home & Building",
                    desc: "O planejamento elétrico do seu imóvel pensado antes da obra: da casa ao edifício, cada circuito dimensionado para hoje e para o futuro.",
                    bullets: [
                        "Estudo de cargas e demanda",
                        "Infraestrutura para reformas e ampliações",
                        "Documentação técnica do projeto",
                    ],
                },
                {
                    tag: "03 · SPDA",
                    title: "Proteção contra descargas atmosféricas",
                    desc: "Sistema SPDA para proteger pessoas e estruturas contra raios, seguindo a NBR 5419 — captação, condução e aterramento.",
                    bullets: [
                        "Para-raios e malha de captação",
                        "Aterramento e equalização",
                        "Inspeção e manutenção do sistema",
                    ],
                    link3d: true,
                },
            ],
            ctaTitle: "Não sabe qual serviço precisa?",
            ctaDesc: "Manda sua dúvida no WhatsApp — a gente entende sua necessidade e indica o caminho certo, sem compromisso.",
            ctaBtn: "Falar com um especialista",
        },
        ti: {
            eyebrow: "T.I · Tecnologia da Informação",
            title: "Tecnologia da Informação",
            sub: "Da ajuda no dia a dia à nuvem e aos dados: T.I completa com o mesmo padrão de engenharia — integrada à parte elétrica do imóvel.",
            cards: [
                {
                    title: "Suporte técnico e help desk",
                    desc: "Atendimento aos usuários, manutenção preventiva e corretiva de computadores, impressoras e periféricos (hardware e software).",
                },
                {
                    title: "Desenvolvimento de software e sistemas",
                    desc: "Criação de sites, aplicativos mobile, softwares sob medida, plataformas web e integração de APIs (front-end e back-end).",
                },
                {
                    title: "Gestão de redes e infraestrutura",
                    desc: "Instalação, monitoramento e manutenção de redes locais (LAN/Wi-Fi), servidores, cabeamento e conectividade.",
                },
                {
                    title: "Computação em nuvem",
                    desc: "Migração, estruturação e gerenciamento de dados e sistemas em servidores remotos (AWS, Azure, Google Cloud).",
                },
                {
                    title: "Segurança da informação e cibersegurança",
                    desc: "Implementação de firewalls, antivírus corporativos, políticas de LGPD, controle de acesso e resposta a incidentes ou ataques (SOC).",
                },
                {
                    title: "Administração de banco de dados (DBA)",
                    desc: "Organização, backup, otimização e proteção de grandes volumes de dados corporativos.",
                },
                {
                    title: "Ciência e análise de dados (Data Science / BI)",
                    desc: "Extração de inteligência de negócios a partir de dados, criação de dashboards e relatórios estratégicos.",
                },
            ],
            cta: "Consultar serviços de T.I",
            photosLabel: "Registro ilustrativo dos atendimentos",
            photos: ["Redes e cabeamento", "Infraestrutura e servidores", "Suporte técnico"],
            ctaCard: {
                title: "Precisa de outro serviço de T.I?",
                desc: "Manda sua necessidade no WhatsApp — a gente responde rápido.",
                btn: "Falar sobre T.I",
            },
        },
        ti3d: {
            eyebrow: "Exemplo prático em 3D",
            title: "Como sua rede funciona na prática",
            sub: "Um exemplo 3D e objetivo da infraestrutura de T.I da ANG: da internet ao roteador, servidor, estações, Wi-Fi e CFTV — selecione um destino e dispare um pacote.",
            send: "Enviar pacote",
            hint: "Selecione um destino",
            dests: ["Servidor", "Estações", "Wi-Fi", "CFTV"],
            labels: ["INTERNET", "ROTEADOR", "SERVIDOR", "ESTAÇÕES", "WI-FI", "CFTV"],
            legend: ["Dados", "Pacote enviado por você"],
            note: "Simulação ilustrativa da topologia — na prática, a ANG instala, monitora e mantém toda essa estrutura para você.",
            telemetry: {
                title: "Status da rede",
                packets: "Pacotes enviados",
                latency: "Latência (último pacote)",
                dest: "Último destino",
                nodes: "Nós online",
                link: "Link de internet: estável",
            },
        },
        spda: {
            eyebrow: "Simulação interativa",
            title: "Veja o raio cair — e o SPDA reagir",
            sub: "Uma simulação 3D de como o sistema de proteção contra descargas atmosféricas intercepta a descarga e conduz a corrente com segurança até o solo.",
            strike: "Disparar raio",
            shieldLabel: "Malha de proteção (SPDA)",
            shieldDesc: "Com a malha ativa, a descarga é interceptada antes de atingir a estrutura.",
            voltage: "Tensão da descarga",
            telemetry: {
                title: "Telemetria da descarga",
                kv: "Tensão",
                ka: "Corrente de pico",
                safety: "Índice de proteção",
                strikes: "Descargas disparadas",
                ground: "R_at ≤ 10 Ω",
                groundLabel: "Aterramento (spec.)",
            },
            safe: "Estrutura protegida",
            unsafe: "Estrutura exposta",
            note: "Simulação ilustrativa, conforme os princípios da NBR 5419 — Proteção contra descargas atmosféricas.",
        },
        gallery: {
            eyebrow: "Processo SPDA",
            title: "Todo o processo do sistema SPDA",
            sub: "Da vala ao aterramento concluído: cada etapa do sistema de proteção contra descargas atmosféricas executada em campo pela ANG — conduzindo a descarga com segurança ao solo.",
            items: [
                "Etapa 01 · Equipe e cabo de cobre em campo",
                "Etapa 02 · Haste de aterramento na vala",
                "Etapa 03 · Moldes de conexão exotérmica",
                "Etapa 04 · Solda exotérmica do condutor",
                "Etapa 05 · Malha de aterramento concluída",
            ],
        },
        coverage: {
            eyebrow: "Área de atendimento",
            title: "Atendemos toda a região de São Paulo",
            sub: "Orçamento e agendamento direto pelo WhatsApp, sem compromisso.",
            regions: [
                {
                    id: "sp",
                    name: "São Paulo",
                    desc: "Capital e Grande São Paulo — todas as zonas.",
                },
                {
                    id: "abc",
                    name: "ABC Paulista",
                    desc: "Santo André · São Bernardo · São Caetano · Diadema e região.",
                },
                {
                    id: "baixada",
                    name: "Baixada Santista",
                    desc: "Santos · Guarujá · Praia Grande · São Vicente e litoral.",
                },
                {
                    id: "interior",
                    name: "Interior Paulista",
                    desc: "Cidades do interior — consulte atendimento na sua cidade.",
                },
            ],
            cta: "Consultar minha região",
        },
        team: {
            title: "Os responsáveis pela sua obra",
            sub: "A Equipe Alpha da ANG em campo: responsabilidade técnica e segurança em cada instalação elétrica, planejamento e SPDA. É essa equipe que atende você — do primeiro contato no WhatsApp à entrega do serviço.",
            badge: "Equipe Alpha · Em campo",
            cta: "Falar com a equipe",
        },
        testimonials: {
            eyebrow: "Depoimentos",
            title: "O que dizem os clientes",
            sub: "Confiança construída obra por obra.",
            items: [
                {
                    name: "Marcos R.",
                    role: "Síndico de edifício · São Paulo",
                    text: "A ANG fez o planejamento elétrico do nosso edifício e modernizou o quadro de energia. Trabalho limpo, no prazo e sem surpresas no orçamento.",
                },
                {
                    name: "Juliana C.",
                    role: "Proprietária de comércio · ABC Paulista",
                    text: "Precisávamos de mais pontos de energia para a loja. Atendimento rápido pelo WhatsApp e execução impecável, sem interromper o movimento.",
                },
                {
                    name: "Ricardo T.",
                    role: "Proprietário de residência · Baixada Santista",
                    text: "Instalaram o SPDA da casa depois de uma descarga na vizinhança. Equipe muito técnica, explicou tudo e deixou o sistema documentado.",
                },
            ],
        },
        quote: {
            eyebrow: "Orçamento rápido",
            title: "Monte seu pedido em 15 segundos",
            sub: "Selecione o serviço, o imóvel e a região. A mensagem chega pronta no nosso WhatsApp.",
            service: "Serviço",
            serviceOptions: [
                "Instalações elétricas",
                "Planejamento Home & Building",
                "SPDA · proteção contra raios",
            ],
            property: "Tipo de imóvel",
            propertyOptions: ["Residência", "Comércio", "Edifício"],
            region: "Região",
            regionOptions: [
                "São Paulo (Capital / Grande SP)",
                "ABC Paulista",
                "Baixada Santista",
                "Interior Paulista",
            ],
            btn: "Pedir orçamento no WhatsApp",
        },
        footer: {
            ctaTitle: "Vamos dar energia ao seu projeto?",
            ctaSub: "Fale agora com a ANG pelo WhatsApp — resposta rápida para orçamentos e dúvidas técnicas.",
            ctaBtn: "Chamar no WhatsApp",
            phoneLabel: "Telefone / WhatsApp",
            navLabel: "Navegação",
            regionsLabel: "Regiões",
            servicesLabel: "Serviços",
            serviceItems: [
                "Instalações elétricas",
                "Planejamento Home & Building",
                "SPDA · proteção contra raios",
            ],
            regions: [
                "São Paulo",
                "Interior Paulista",
                "Baixada Santista",
                "ABC Paulista",
            ],
            rights: "Todos os direitos reservados.",
        },
        floating: "Falar com a ANG",
    },
    en: {
        meta: {
            title: "ANG — Electrical Engineering & SPDA | São Paulo, Brazil",
        },
        nav: {
            home: "Home",
            team: "Team",
            services: "Services",
            ti: "IT",
            spda: "3D LPS",
            works: "Projects",
            coverage: "Coverage",
            testimonials: "Testimonials",
            quote: "Get a Quote",
            cta: "Quote on WhatsApp",
        },
        hero: {
            badge: "Ready for new projects — São Paulo & region",
            lines: ["ELECTRICAL", "ENGINEERING", "& PROTECTION."],
            sub: "Electrical installations, Home & Building planning and LPS — lightning protection systems for houses, stores and buildings.",
            cta1: "Get a quote on WhatsApp",
            cta2: "Explore 3D lightning system",
            chipTop: "LPS · NBR 5419 (IEC 62305)",
            chipBottom: "4 regions served in SP",
            metrics: [
                "Residential, commercial & building wiring",
                "Home & Building planning",
                "LPS · lightning protection",
                "São Paulo · Countryside · Coast · ABC",
            ],
        },
        marquee: [
            "ELECTRICAL INSTALLATIONS",
            "LPS · NBR 5419",
            "HOME & BUILDING PLANNING",
            "SÃO PAULO CAPITAL",
            "ABC DISTRICT",
            "SANTOS COAST",
            "SÃO PAULO COUNTRYSIDE",
            "QUOTES: +55 11 94137-0079",
        ],
        services: {
            eyebrow: "What we do",
            title: "Full electrical scope, from blueprint to lightning rod",
            sub: "From project design to atmospheric protection: one team for every electrical need of your property.",
            items: [
                {
                    tag: "01 · WIRING",
                    title: "Electrical installations",
                    desc: "Execution and maintenance of electrical installations for homes, stores and buildings — from new power points to panel upgrades.",
                    bullets: [
                        "Panels, circuits and breakers",
                        "Lighting, outlets and power points",
                        "Upgrades and electrical improvements",
                    ],
                },
                {
                    tag: "02 · PLANNING",
                    title: "Home & Building planning",
                    desc: "Your property's electrical planning designed before construction: from house to building, every circuit sized for today and tomorrow.",
                    bullets: [
                        "Load and demand studies",
                        "Infrastructure for renovations and expansions",
                        "Technical project documentation",
                    ],
                },
                {
                    tag: "03 · LPS",
                    title: "Atmospheric discharge protection",
                    desc: "LPS (SPDA) to protect people and structures from lightning, following NBR 5419 — interception, conduction and grounding.",
                    bullets: [
                        "Air terminals and mesh",
                        "Grounding and equipotentialization",
                        "System inspection and maintenance",
                    ],
                    link3d: true,
                },
            ],
            ctaTitle: "Not sure which service you need?",
            ctaDesc: "Send your question on WhatsApp — we will understand your needs and point you in the right direction, no strings attached.",
            ctaBtn: "Talk to a specialist",
        },
        ti: {
            eyebrow: "IT · Information Technology",
            title: "Information Technology",
            sub: "From day-to-day support to cloud and data: complete IT with the same engineering standard — integrated with the property's electrical installation.",
            cards: [
                {
                    title: "Technical support & help desk",
                    desc: "User support, preventive and corrective maintenance of computers, printers and peripherals (hardware and software).",
                },
                {
                    title: "Software & systems development",
                    desc: "Websites, mobile apps, custom software, web platforms and API integration (front-end and back-end).",
                },
                {
                    title: "Network & infrastructure management",
                    desc: "Installation, monitoring and maintenance of local networks (LAN/Wi-Fi), servers, cabling and connectivity.",
                },
                {
                    title: "Cloud computing",
                    desc: "Migration, structuring and management of data and systems on remote servers (AWS, Azure, Google Cloud).",
                },
                {
                    title: "Information security & cybersecurity",
                    desc: "Firewalls, corporate antivirus, LGPD policies, access control and incident response (SOC).",
                },
                {
                    title: "Database administration (DBA)",
                    desc: "Organization, backup, optimization and protection of large volumes of corporate data.",
                },
                {
                    title: "Data science & analytics (BI)",
                    desc: "Business intelligence from data, dashboards and strategic reports.",
                },
            ],
            cta: "Ask about IT services",
            photosLabel: "Illustrative view of our services",
            photos: ["Networks & cabling", "Infrastructure & servers", "Technical support"],
            ctaCard: {
                title: "Need another IT service?",
                desc: "Send your need on WhatsApp — we reply fast.",
                btn: "Talk about IT",
            },
        },
        ti3d: {
            eyebrow: "Practical 3D example",
            title: "How your network works in practice",
            sub: "An objective 3D example of ANG's IT infrastructure: from the internet to the router, server, workstations, Wi-Fi and CCTV — pick a destination and send a packet.",
            send: "Send packet",
            hint: "Select a destination",
            dests: ["Server", "Workstations", "Wi-Fi", "CCTV"],
            labels: ["INTERNET", "ROUTER", "SERVER", "WORKSTATIONS", "WI-FI", "CCTV"],
            legend: ["Data", "Packet sent by you"],
            note: "Illustrative topology simulation — in practice, ANG installs, monitors and maintains this entire structure for you.",
            telemetry: {
                title: "Network status",
                packets: "Packets sent",
                latency: "Latency (last packet)",
                dest: "Last destination",
                nodes: "Nodes online",
                link: "Internet link: stable",
            },
        },
        spda: {
            eyebrow: "Interactive simulation",
            title: "Watch lightning strike — and the LPS react",
            sub: "A 3D simulation of how a Lightning Protection System intercepts the discharge and safely conducts the current to the ground.",
            strike: "Trigger lightning",
            shieldLabel: "Protection mesh (LPS)",
            shieldDesc: "With the mesh active, the strike is intercepted before reaching the structure.",
            voltage: "Discharge voltage",
            telemetry: {
                title: "Discharge telemetry",
                kv: "Voltage",
                ka: "Peak current",
                safety: "Protection index",
                strikes: "Strikes triggered",
                ground: "R_gnd ≤ 10 Ω",
                groundLabel: "Grounding (spec.)",
            },
            safe: "Structure protected",
            unsafe: "Structure exposed",
            note: "Illustrative simulation, following NBR 5419 — Lightning Protection principles.",
        },
        gallery: {
            eyebrow: "LPS process",
            title: "The full lightning protection process",
            sub: "From trench to finished grounding: every stage of the lightning protection system executed in the field by ANG — safely conducting the strike to the ground.",
            items: [
                "Step 01 · Team and copper cable on site",
                "Step 02 · Grounding rod in the trench",
                "Step 03 · Exothermic connection molds",
                "Step 04 · Exothermic conductor weld",
                "Step 05 · Grounding mesh completed",
            ],
        },
        coverage: {
            eyebrow: "Service area",
            title: "We cover the entire São Paulo region",
            sub: "Quotes and scheduling straight through WhatsApp, no strings attached.",
            regions: [
                {
                    id: "sp",
                    name: "São Paulo",
                    desc: "Capital and Greater São Paulo — all zones.",
                },
                {
                    id: "abc",
                    name: "ABC District",
                    desc: "Santo André · São Bernardo · São Caetano · Diadema and region.",
                },
                {
                    id: "baixada",
                    name: "Santos Coast",
                    desc: "Santos · Guarujá · Praia Grande · São Vicente and the coast.",
                },
                {
                    id: "interior",
                    name: "São Paulo Countryside",
                    desc: "Countryside cities — ask about your city.",
                },
            ],
            cta: "Ask about my region",
        },
        team: {
            title: "The team behind your project",
            sub: "Team Alpha of ANG in the field: technical responsibility and safety in every electrical installation, planning job and LPS. This is the team that serves you — from the first WhatsApp message to the final handover.",
            badge: "Team Alpha · On site",
            cta: "Talk to the team",
        },
        testimonials: {
            eyebrow: "Testimonials",
            title: "What clients say",
            sub: "Trust built project by project.",
            items: [
                {
                    name: "Marcos R.",
                    role: "Building manager · São Paulo",
                    text: "ANG handled our building's electrical planning and modernized the energy panel. Clean work, on schedule, no budget surprises.",
                },
                {
                    name: "Juliana C.",
                    role: "Store owner · ABC District",
                    text: "We needed more power points for the store. Fast WhatsApp support and flawless execution without interrupting business.",
                },
                {
                    name: "Ricardo T.",
                    role: "Homeowner · Santos Coast",
                    text: "They installed the house lightning protection after a nearby strike. Very technical team, explained everything, left the system documented.",
                },
            ],
        },
        quote: {
            eyebrow: "Quick quote",
            title: "Build your request in 15 seconds",
            sub: "Pick the service, the property and the region. The message arrives ready on our WhatsApp.",
            service: "Service",
            serviceOptions: [
                "Electrical installations",
                "Home & Building planning",
                "LPS · lightning protection",
            ],
            property: "Property type",
            propertyOptions: ["House", "Store", "Building"],
            region: "Region",
            regionOptions: [
                "São Paulo (Capital / Greater SP)",
                "ABC District",
                "Santos Coast",
                "São Paulo Countryside",
            ],
            btn: "Get a quote on WhatsApp",
        },
        footer: {
            ctaTitle: "Let's power up your project?",
            ctaSub: "Talk to ANG on WhatsApp now — quick answers for quotes and technical questions.",
            ctaBtn: "Chat on WhatsApp",
            phoneLabel: "Phone / WhatsApp",
            navLabel: "Navigation",
            regionsLabel: "Regions",
            servicesLabel: "Services",
            serviceItems: [
                "Electrical installations",
                "Home & Building planning",
                "LPS · lightning protection",
            ],
            regions: [
                "São Paulo",
                "São Paulo Countryside",
                "Santos Coast",
                "ABC District",
            ],
            rights: "All rights reserved.",
        },
        floating: "Talk to ANG",
    },
};
